import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Winter_Weather/FeatureServer/1&source=sd)
 *  */
const WINTER_WEATHER_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  1.28,
  colors.amber[300],
  3.28,
  colors.orange[500],
  6,
  colors.red[500],
  12.6,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Winter_Weather/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 12.6 – 31", 11],
    ["> 6 – 12.6", 9],
    ["> 3.28 – 6", 7],
    ["> 1.28 – 3.28", 5],
    ["0 – 1.28", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: WINTER_WEATHER_STOPS[row[1] as number],
  }));
};

export const winterWeather = {
  stops: WINTER_WEATHER_STOPS,
  props: getLegendRows(),
};
